import React, { useState } from "react";
import PropTypes from "prop-types";
import { FiLock, FiUserPlus } from "react-icons/fi";
import { GoPlus } from "react-icons/go";
import { useTranslation } from "react-i18next";
import SortFilterModal from "./SortFilterModal";
import { useSelector } from "react-redux";
import { CiFilter } from "react-icons/ci";
import { MdOutlineSort } from "react-icons/md";
import { Button } from "antd";
import { PERMISSIONS } from "../../../../config/permission";
import ProtectedAction from "../../../../Routes/ProtectedRoutes/ProtectedAction";

const Header = ({
  title,
  count,
  sortOptions,
  filterOptions,
  department,
  onSortFilterApply,
  navigateToManageRoles, // function from AllTeachers
  handleCreateRole,
  isAdmin,
  currentSort,
  currentFilters,
  onSearchChange,
  searchValue,
}) => {
  const { t } = useTranslation("admUserProfile");
  const [isSortModalOpen, setSortModalOpen] = useState(false);
  const teacher = useSelector((store) => store.common.auth.userRole);

  return (
    <>
      <div className="flex justify-between items-center mb-6 p-4 bg-white rounded-xl shadow-sm ">
        {/* Left Section: Title and Count */}
        <div className="flex items-center">
          <h2 className="flex items-center gap-3 staff-heading ">
            {title}
            <span className="relative inline-flex items-center justify-center">
              {/* Outer gradient ring */}
              <span className="inline-flex items-center justify-center min-w-[1.75rem] h-7 rounded-full bg-gradient-to-r from-pink-500 via-fuchsia-500 to-purple-600 p-[2px] shadow-md">
                {/* Inner badge */}
                <span
                  className="flex items-center justify-center min-w-[1.5rem] h-full px-2 rounded-full bg-white text-sm font-semibold text-pink-600 "
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "4rem",
                  }}
                >
                  {count}
                </span>
              </span>
            </span>
          </h2>

          {/* Sort & Filter Modal */}
          {isAdmin && (
            <SortFilterModal
              isOpen={isSortModalOpen}
              onClose={() => setSortModalOpen(false)}
              onApply={onSortFilterApply}
              sortOptions={sortOptions}
              filterOptions={filterOptions}
              department={department}
              initialSort={currentSort}
              initialFilters={currentFilters}
            />
          )}
        </div>

        {/* Right Section: Action Buttons */}
        <div className="flex items-center gap-4">

          <div className="flex items-center justify-end">
            <input
              type="text"
              placeholder="Search by name, email"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="border rounded-xl px-3 py-2.5 w-full sm:w-64 me-4"
            />

            <button
              size="large"

              onClick={() => setSortModalOpen(true)}
              aria-label="Open Sort and Filter Modal"
              style={{
                background: "",
                color: "#ffffff",
                border: "none",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
              }}
              className="px-4 py-2 btn-gradient "
            >
              <span>{t("Sort")}</span>
              <MdOutlineSort
                style={{ fontSize: "1.25rem", color: "#ffffff" }}
              />
            </button>
          </div>


          <ProtectedAction requiredPermission={PERMISSIONS.GET_ALL_ROLE}>
            <button
              onClick={() => navigateToManageRoles(department)}
              className="px-4 py-[11px] btn-gradient text-white rounded-xl inline-flex items-center gap-2 hover:opacity-90 transition duration-200"
              aria-label="Manage Roles"
            >
              <FiLock className="text-white" />
              {t("Manage Roles")}
            </button>
          </ProtectedAction>

          <ProtectedAction requiredPermission={PERMISSIONS.CREATE_ROLE}>
            <button
              onClick={handleCreateRole}
              className="inline-flex items-center border border-gray-300 rounded-full ps-4 bg-white hover:shadow-lg transition duration-200 gap-2"
              aria-label="Create New Role"
            >
              <span className="text-gray-800 font-medium">
                {t("Create Role")}
              </span>
              <div className="w-11 h-11 rounded-full btn-gradient flex items-center justify-center text-white">
                <FiUserPlus size={20} />
              </div>
            </button>
          </ProtectedAction>
        </div>

      </div>
    </>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  sortOptions: PropTypes.array.isRequired,
  filterOptions: PropTypes.array.isRequired,
  department: PropTypes.string,
  onSortFilterApply: PropTypes.func.isRequired,
  navigateToManageRoles: PropTypes.func.isRequired,
  handleCreateRole: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  currentSort: PropTypes.string,
  currentFilters: PropTypes.array,
};

Header.defaultProps = {
  department: "",
  currentSort: null,
  currentFilters: [],
};

export default Header;
